import { createSelector } from "reselect";
import moment from "moment";
import CPF from "gerador-validador-cpf";

export const Types = {
  GET_REQUEST: "documents/GET_REQUEST",
  GET_SUCCESS: "documents/GET_SUCCESS",
  GET_FAILURE: "documents/GET_FAILURE",

  GET_LIST_REQUEST: "documents/GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "documents/GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "documents/GET_LIST_FAILURE",

  GET_STORES_REQUEST: "documents/GET_STORES_REQUEST",
  GET_STORES_SUCCESS: "documents/GET_STORES_SUCCESS",
  GET_STORES_FAILURE: "documents/GET_STORES_FAILURE",

  APPROVE_REQUEST: "documents/APPROVE_REQUEST",
  APPROVE_SUCCESS: "documents/APPROVE_SUCCESS",
  APPROVE_FAILURE: "documents/APPROVE_FAILURE",

  REPPROVE_REQUEST: "documents/REPPROVE_REQUEST",
  REPPROVE_SUCCESS: "documents/REPPROVE_SUCCESS",
  REPPROVE_FAILURE: "documents/REPPROVE_FAILURE",

  GET_STATES_REQUEST: "documents/GET_STATES_REQUEST",
  GET_STATES_SUCCESS: "documents/GET_STATES_SUCCESS",
  GET_STATES_FAILURE: "documents/GET_STATES_FAILURE",
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  update: {
    loading: false,
  },

  stores: {
    data: [],
    loading: true,
  },

  search: {
    data: [],
    loading: false,
  },

  reasons: {
    data: [],
    loading: false,
  },

  approve: {
    loading: false,
  },

  repprove: {
    loading: false,
  },

  states: {
    data: [],
    loading: false,
  },
};

export default function documents(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.document.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.documents.data,
        page: action.payload.documents.meta.current_page,
        totals: action.payload.documents.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.GET_STORES_REQUEST:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: true,
        },
      };
    case Types.GET_STORES_SUCCESS:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
          data: action.payload.stores.data,
        },
      };
    case Types.GET_STORES_FAILURE:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
        },
      };
    case Types.SEARCH_REQUEST:
      return {
        ...state,
        search: {
          ...state.search,
          loading: true,
        },
      };
    case Types.SEARCH_SUCCESS:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
          data: action.payload.documents.data,
        },
      };
    case Types.SEARCH_FAILURE:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
        },
      };
    case Types.APPROVE_REQUEST:
      return {
        ...state,
        approve: {
          ...state.approve,
          loading: true,
        },
      };
    case Types.APPROVE_SUCCESS:
    case Types.APPROVE_FAILURE:
      return {
        ...state,
        approve: {
          ...state.approve,
          loading: false,
        },
      };
    case Types.REPPROVE_REQUEST:
      return {
        ...state,
        repprove: {
          ...state.repprove,
          loading: true,
        },
      };
    case Types.REPPROVE_SUCCESS:
    case Types.REPPROVE_FAILURE:
      return {
        ...state,
        repprove: {
          ...state.repprove,
          loading: false,
        },
      };
    case Types.GET_STATES_REQUEST:
      return {
        ...state,
        states: {
          ...state.states,
          loading: true,
        },
      };
    case Types.GET_STATES_SUCCESS:
      return {
        ...state,
        states: {
          ...state.states,
          loading: false,
          data: action.payload.states.data,
        },
      };
    case Types.GET_STATES_FAILURE:
      return {
        ...state,
        states: {
          ...state.states,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getDocumentRequest: (id) => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getDocumentSuccess: (document) => ({
    type: Types.GET_SUCCESS,
    payload: { document },
  }),

  getDocumentFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getDocumentsRequest: (page = 1, filters = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, filters },
  }),

  getDocumentsSuccess: (documents) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { documents },
  }),

  getDocumentsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  getDocumentStoresRequest: (query = "") => ({
    type: Types.GET_STORES_REQUEST,
    payload: { query },
  }),

  getDocumentStoresSuccess: (stores) => ({
    type: Types.GET_STORES_SUCCESS,
    payload: { stores },
  }),

  getDocumentStoresFailure: () => ({
    type: Types.GET_STORES_FAILURE,
  }),

  searchDocumentsSuccess: (documents) => ({
    type: Types.SEARCH_SUCCESS,
    payload: { documents },
  }),

  searchDocumentsFailure: () => ({
    type: Types.SEARCH_FAILURE,
  }),

  approveDocumentRequest: (id, data, redirect_to = false) => ({
    type: Types.APPROVE_REQUEST,
    payload: { id, data, redirect_to },
  }),

  approveDocumentSuccess: () => ({
    type: Types.APPROVE_SUCCESS,
  }),

  approveDocumentFailure: () => ({
    type: Types.APPROVE_FAILURE,
  }),

  repproveDocumentRequest: (id, data, redirect_to = false) => ({
    type: Types.REPPROVE_REQUEST,
    payload: { id, data, redirect_to },
  }),

  repproveDocumentSuccess: () => ({
    type: Types.REPPROVE_SUCCESS,
  }),

  repproveDocumentFailure: () => ({
    type: Types.REPPROVE_FAILURE,
  }),

  getStatesDocumentRequest: () => ({
    type: Types.GET_STATES_REQUEST,
  }),

  getStatesDocumentSuccess: (states) => ({
    type: Types.GET_STATES_SUCCESS,
    payload: { states },
  }),

  getStatesDocumentFailure: () => ({
    type: Types.GET_STATESS_FAILURE,
  }),
};

export const Selectors = {
  documents: createSelector(
    (state) => state,
    (documents) =>
      documents.map((d) => ({
        ...d,
        attributes: {
          ...d.attributes,
          document: {
            ...d.attributes.document,
            sentDate: moment(d.attributes.document.created_at).format(
              "DD/MM/YYYY [às] HH:mm"
            ),
            documentable: {
              ...d.attributes.document.documentable,
              cpf: CPF.format(d.attributes.document.documentable?.cpf),
              store_place: {
                ...d.attributes.document.documentable?.store_place,
                uf:
                  d.attributes.document.documentable?.store_place.uf !== null
                    ? d.attributes.document.documentable?.store_place.uf.toUpperCase()
                    : '-',
              },
            },
          },
        },
      }))
  ),

  stores: createSelector(
    (state) => state,
    (stores) =>
      stores.map((store) => ({ value: store.id, label: store.attributes.name }))
  ),

  states: createSelector(
    (state) => state,
    (states) =>
      states.map((state) => ({ value: state.id, label: state.attributes.name }))
  ),
};
